<template>
  <div class="height-100" :style="imageConnexionCss">
    <div class="card">
      <div class="card-content-login has-background-white is-fixed">
        <div class="has-text-centered mgb-40px">
          <img src="/static/img/connexion/logoAffixe.svg" class="width-250"/>
        </div>
        <error-msg-component :messages="messages" class="mgt-20px"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <form  @submit.prevent="login()">
          <b-field :label="$t('connexion.site')"
                   class="mgt-20px obligatoire" custom-class="has-text-default">
            <b-input v-model="site" name="organization" autocomplete="organization"></b-input>
          </b-field>
          <b-field :label="$t('connexion.identifiant')"
                   class="mgt-20px obligatoire" custom-class="has-text-default">
            <b-input v-model="email" name="username" autocomplete="username"></b-input>
          </b-field>
          <b-field :label="$t('connexion.mdp')"
                   class="mgt-20px obligatoire" custom-class="has-text-default">
            <b-input
              v-model="password"
              type="password"
              autocomplete="current-password"
              password-reveal>
            </b-input>
          </b-field>
          <div class="has-text-right mgt-20px">
            <a @click="afficherModalMdpOublie = true"
               class="has-text-primary lien">{{ $t('connexion.actions.mdpOublie')}}</a>
          </div>
          <button class="button is-primary mgt-40px is-fullwidth has-text-weight-bold"
                  type="submit">
            {{ $t('connexion.actions.connexion')}}
          </button>
          <div class="mgt-20px has-text-centered" v-if="afficherInfo">
            <p>{{ $t('connexion.info.siteOptimise')}}</p>
            <p>{{ $t('connexion.info.changeNavigateur')}}</p>
          </div>
        </form>
        <footer class="footer-connexion has-text-default is-size-8">
          {{ $t('connexion.info.produit')}}
        </footer>
      </div>
    </div>
    <b-modal
      :active.sync="afficherModalMdpOublie"
      :width="600"
      :can-cancel="['escape', 'outside']"
      :full-screen="false"
      :trap-focus="false"
      :close-on-esc="true"
      :close-on-click-outside="true"
      :destroy-on-hide="true"
      :title="$t('connexion.actions.mdpOublie')"
      >
      <popup-mdp-oublie @close="afficherModalMdpOublie = false" :site="site"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import Bowser from 'bowser';
import { AUTHORIZED_BROWSERS } from '@/configuration/browserConf';
import validation from '@/services/connexion/connexionMessageErreur';
import translate from '@/services/connexion/champsConnexionTranslator';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageInformation from '@/services/general/messageInformation';
import { PAGE_DEFAULT } from '@/router/routerConf';
import * as types from '@/store/modules/permissions-mutation-type';
import addSocieteAndAgence from '@/services/utilisateur/addSocieteAndAgence';
import DOMAINE from '@/configuration/bodac/contact/contactConf';
import { getImageConnexion } from '@/api/imageConnexion';
import popupMdpOublie from './popupMotDePasseOublie';

const User = createNamespacedHelpers('user');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const parametres = createNamespacedHelpers('parametres');
const categorieVente = createNamespacedHelpers('categorieVente');

export default {
  name: 'FormConnexion',
  data() {
    return {
      email: '',
      password: '',
      site: '',
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      env: process.env.VUE_APP_BACK,
      afficherModalMdpOublie: false,
      imageUrl: null,
      isFetchingImage: false,
    };
  },
  components: {
    errorMsgComponent,
    popupMdpOublie,
  },
  computed: {
    afficherInfo() {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const browserName = browser.getBrowser().name.toUpperCase();
      return !AUTHORIZED_BROWSERS.includes(browserName);
    },
    autoriserAuthentificationAffixe1() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.autoriserAuthentificationAffixe1.key,
      );
    },
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    imageConnexionCss() {
      return {
        'background-image': `${this.isFetchingImage ? '' : `url(${this.imageUrl ?? '/static/img/Background-login-default.png'})`}`,
        'background-size': 'cover',
      };
    },
  },
  methods: {
    ...parametres.mapActions({
      purgerParametres: 'purgerParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...societe.mapActions({
      setMultipleAgenceActive: 'setMultipleAgenceActive',
      actionsSetSocieteId: 'setSocieteId',
      actionsSetSocieteOfUser: 'setSocieteOfUser',
      loadSocietes: 'loadSocietes',
    }),
    ...User.mapActions({
      actionsLogIn: 'logIn',
      actionLogOut: 'logOut',
    }),
    ...permissions.mapActions({
      loadPermissions: 'loadPermissions',
    }),
    ...permissions.mapMutations({
      setUserAffixe1: types.SET_USER_AFFIXE1,
    }),
    ...categorieVente.mapActions({
      loadCategorieVente: 'loadCategories',
    }),
    async login() {
      const loadingComponent = this.$buefy.loading.open();
      this.email = this.email.toLowerCase();
      this.site = this.site.toLowerCase();
      try {
        await this.actionsLogIn({
          email: this.email,
          password: this.password,
          site: this.site,
        });
        if (this.utilisateur.domaine === DOMAINE) {
          await this.actionLogOut('logOut');
          messageInformation(this.$t('connexion.info.infoConnexionPortail'), 'is-danger');
          return;
        }
        if (this.email === 'support@quadra-diffusion.fr') {
          messageInformation(this.$t('connexion.info.connexionSupportAffixe1'), 'is-warning');
        }
        await this.loadParametresInterne([
          typesParametres.PARAMETRES_INTERNE_KEYS.autoriserAuthentificationAffixe1.key]);

        if (this.email.includes('@') || (this.email === 'admin' && this.site === '')) {
          this.setUserAffixe1(true);
          await addSocieteAndAgence(this.utilisateur);
          if (this.email.includes('@')
              && this.autoriserAuthentificationAffixe1 === 'warn') {
            messageInformation(this.$t('connexion.info.connexionAffixe1'), 'is-warning');
          }
        }
        await this.loadSocietes({});
        await this.actionsSetSocieteOfUser(this.utilisateur);
        await this.setMultipleAgenceActive(this.utilisateur.agences.filter((agence) => {
          return agence.societeId === this.utilisateur.agence.societeId;
        }));
        await this.actionsSetSocieteId(this.utilisateur.agence.societeId);
        await this.loadCategorieVente();
        await this.loadPermissions();
        this.error = false;
        this.$router.push(this.$route.query.redirect || PAGE_DEFAULT);
      } catch (e) {
        this.error = true;
        if (this.env === 'staging') {
          // On remet à blanc
          this.site = '';
        }

        if (e.response?.status === 401) {
          this.messages = [];
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = validation(e.response);
          return;
        }
        if (e.response?.data?.error) {
          this.messages = [];
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = validation(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          return;
        }

        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    sendMailMdpOublie() {
      this.$buefy.toast.open({
        message: this.$t('connexion.info.mailEnvoye'),
        type: 'is-success',
        position: 'is-bottom',
        duration: 5000,
      });
    },
    async loadImage() {
      this.isFetchingImage = true;
      try {
        // Le chargement de l'image ne doit pas être bloquant
        const image = (await getImageConnexion())?.data?.result;
        this.imageUrl = image?.chemin;
      } finally {
        this.isFetchingImage = false;
      }
    },
  },
  async mounted() {
    this.purgerParametres();
    this.setInformationPage(this.$t('pageGeneral.connexion'));
    await this.loadImage();
    this.site = this.$route.query.site;
  },
};
</script>
